import { CarePlanRenewalInfo } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanRenewal.ts';
import { GeneratePrescriptionInfo } from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/PrescriptionInfo.ts';
import { WizardAction, WizardState, wizardUtils } from '@/utils/wizardUtils.ts';

export type CarePlanInfoStep = {
  step: 'CarePlan';
  data: CarePlanRenewalInfo;
};

export type PrescriptionInfoStep = {
  step: 'PrescriptionInfo';
  data: GeneratePrescriptionInfo & {
    prescription: Blob;
  };
};

export type PrescriptionSigningStep = {
  step: 'PrescriptionSign';
  data: undefined;
};

export type PatientRenewalSteps = [
  CarePlanInfoStep,
  PrescriptionInfoStep,
  PrescriptionSigningStep,
];
export type PatientRenewalState = WizardState<PatientRenewalSteps>;
export type PatientRenewalAction = WizardAction<PatientRenewalSteps>;
export const patientRenewalWizard = wizardUtils<PatientRenewalSteps>([
  'CarePlan',
  'PrescriptionInfo',
  'PrescriptionSign',
]);
